<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
			<div class="row" style="position: relative;">
				<img src="../../assets/img/cpzxBanner.png" style="width: 100%;" />
			</div>
			<div class="row al-c ju-c" style="height: 80px;background-color: #f7f7f7;">
				<div class="item-no al-c" style="width: 1200px;">
					<div class="item-no centerbtn ju-c al-c" style="margin-right: 120px;">
						<i class="el-icon-monitor" style="font-size: 24px;color: #fff;"></i>
						<div class="item-no" style="font-size: 24px;color: #fff;margin-left: 10px;" >云MES平台</div>
					</div>
					<div class="item-no ju-c com" :class="{'active':index==1}" @click="changeIndex(1)"
						style="width: 150px;cursor: pointer;">
						MES系统
					</div>
					<div class="item-no ju-c com" :class="{'active':index==2}" @click="changeIndex(2)"
						style="width: 150px;cursor: pointer;">
						WMS系统
					</div>
					<div class="item-no ju-c com" :class="{'active':index==3}" @click="changeIndex(3)"
						style="width: 150px;cursor: pointer;">
						APS系统
					</div>
					<div class="item-no ju-c com" :class="{'active':index==4}" @click="changeIndex(4)"
						style="width: 150px;cursor: pointer;">
						EAM系统
					</div>
					<div class="item-no ju-c com" :class="{'active':index==5}" @click="changeIndex(5)"
						style="width: 150px;cursor: pointer;">
						SCADA系统
					</div>
				</div>

			</div>
			<YMES v-if="index==0" />
			<MES v-if="index==1" />
			<WES v-if="index==2" />
			<APS v-if="index==3" />
			<EAM v-if="index==4" />
			<CSADA v-if="index==5" />
			<Foot />
		</div>
	</div>
</template>

<script>
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";
	import MES from "./MES.vue";
	import WES from "./WES.vue";
	import APS from "./APS.vue";
	import EAM from "./EAM.vue";
	import CSADA from "./SCADA.vue";
	import YMES from "./YMES.vue";
	
	export default {
		name: "App",
		components: {
			Nav,
			Foot,
			MES,
			CSADA,
			WES,
			APS,
			EAM,
			YMES
		},
		data() {
			return {
				curHeight: 0,
				index: 1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			changeIndex(e) {
				this.index = e
			}
		},
		mounted() {
			var that = this;
			if(this.$route.query.pro){
				this.index=this.$route.query.pro
			}
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>
	.main-content {
		min-height: 100%;
		min-width: 1400px;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
		/* background: #f7f7f7; */
	}

	.prduct-box {
		width: 1200px;
		/* padding-top: 60px; */
		padding-bottom: 100px;
		margin: 0 auto;
	}

	.center-body {
		margin: 0 auto;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}

	.centerbtn {
		width: 240px;
		border-radius: 25px;
		background-color: #ff7e00;
		height: 50px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		
	}

	.com {
		font-size: 18px;
		color: #aaaaaa;
	}

	.active {
		color: #0070FD;
	}
</style>
